<template>
  <v-content>
    <UseTermsModal v-model="showServiceTerms"></UseTermsModal>
    <PrivacyPolicyTermsModal v-model="showPolicyTerms"></PrivacyPolicyTermsModal>
    <v-container>
      <v-layout>
        <div style="max-width: 500px;margin:0 auto" @click.once="gaLightBox()">
          <v-layout row wrap>
            <v-flex pa-4>
              <div class="head-login mb-4">
                <p>Escolha sua senha de acesso</p>
              </div>
              <div class="box-xs-form">
                <InputPassword
                  type="password"
                  v-model="password"
                  insideInput="Moderada"
                  textLabel="Escolha sua senha"
                  helpLabel="Sua senha deve conter ao menos 8 caracteres com letras e números."
                  ref="passwordInput"
                  @levelPassword="changeLevelPassword"
                  @input="disabledButton"
                  :force="true"
                />
              </div>

              <div class="box-xs-form mt-3">
                <InputPassword
                  type="password"
                  v-model="passwordConfirm"
                  insideInput="Moderada"
                  textLabel="Confirme sua senha"
                  ref="passwordConfirm"
                  @input="disabledButton"
                  :force="false"
                />
              </div>

              <v-layout row wrap class="mt-5 mb-3"
              v-if="showLGPD">
                <div>
                  <div v-html="termText" style="padding: 0; margin: 0;"/>
                  <div class="check-terms">
                    <v-radio-group v-model="agreed" row
                    @change="disabledButton">
                      <v-radio
                        :value="true"
                        :label="`Sim, autorizo`"
                      ></v-radio>
                      <v-radio
                        :value="false"
                        :label="`Não autorizo`"
                      ></v-radio>                     
                    </v-radio-group>
                  </div>
                </div>
              </v-layout>

              <v-row v-if="landingPageConfig.campaignId === 675" class="text-body-2">
                <v-col cols="12">
                  <v-checkbox
                    v-model="agreedWithTerms"
                    @change="disabledButton"
                    class="checkbox-wrap"
                  >
                    <template v-slot:label>
                      <label class="terms-wrap" style="text-align: left;">
                        Aceito os
                        <a
                          href="https://aucreceipts.blob.core.windows.net/filesprod/Termo-de-Condicoes-Gerais-de-Uso-FLA-ANJO2024_250807_193919.pdf"
                          target="_blank"
                          rel="noopener"
                        > termos do Flamengo, </a>
                        <a href="#" @click.prevent="showServiceTerms = !showServiceTerms"> termos de uso gerais </a>e
                        <a href="#" @click.prevent="showPolicyTerms = !showPolicyTerms"> política de privacidade</a>.
                      </label>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <v-layout row wrap v-else>
                <div class="check-terms">
                  <v-checkbox
                    v-model="agreedWithTerms"
                    @change="disabledButton"
                    :label="`Aceito os `"
                  ></v-checkbox>
                </div>
                <div class="terms">
                  <a
                    href="javascript:;"
                    @click="showServiceTerms = !showServiceTerms; $gtag('send', 'event', 'Termos De Uso', 'Novo Cadastro', 'Link_Text')"
                  >termos de uso</a>
                </div>
                <div class="terms terms-color">e</div>
                <div class="terms">
                  <a
                    href="javascript:;"
                    @click="showPolicyTerms = !showPolicyTerms; $gtag('send', 'event', 'Política de Privacidade', 'Novo Cadastro', 'Link_Text')"
                  >política de privacidade.</a>
                </div>
              </v-layout>

              <div class="text-xs-center">
                <v-btn
                  flat
                  round
                  color="white"
                  class="btn-primary px-5 mt-4"
                  large
                  @click="recoverPassword(); $gtag('send', 'event', 'Cadastrar Senha', 'Novo Cadastro', 'Button')"
                  :disabled="disableButtonRegister"
                >CADASTRAR</v-btn>
              </div>
            </v-flex>
          </v-layout>
          <LGPDTerm :dialog="showLGPDTerm" @close="closeLGPD" class="mt-4"/>
        </div>
      </v-layout>
    </v-container>
  </v-content>
</template>
<script type="plain/text">
import Container from "@/components/Container.vue";
import InputPassword from "@/components/input/InputPassword.vue";
import UserService from "@/scripts/services/user.service";
import PersonService from "@/scripts/services/person.service";
import { Routes } from "@/scripts/models/enums/routes.enum.js";
import UseTermsModal from "@/components/UseTermsModal.vue";
import PrivacyPolicyTermsModal from "@/components/PrivacyPolicyTermsModal.vue";
import CampaignService from "@/scripts/services/campaign.service";
import LoginService from "@/scripts/services/login.service";
import FileImage from "@/components/FileImage.vue";
import UserCompanyConsentTermService from "@/scripts/services/userCompanyConsentTerm.service";

// Models
import UserCompanyConsentTerm from "@/scripts/models/userCompanyConsentTerm.model";

//VUEX
import { mapGetters } from "vuex";

// Components
import LGPDTerm from "@/components/LGPDTerm.vue";

export default {
  props: ["person", "landingPageConfig"],
  components: {
    Container,
    InputPassword,
    UseTermsModal,
    PrivacyPolicyTermsModal,
    FileImage,
    LGPDTerm,
  },
  data() {
    return {
      password: "",
      passwordConfirm: "",
      agreedWithTerms: false,
      showPolicyTerms: false,
      showServiceTerms: false,
      levelPassword: 0,
      optin: true,
      userService: new UserService(),
      personService: new PersonService(),
      campaignService: new CampaignService(),
      loginService: new LoginService(),
      userCompanyConsentTerm: new UserCompanyConsentTerm(),
      userCompanyConsentTermService: new UserCompanyConsentTermService(),
      disableButtonRegister: true,      
      agreed: null,
      showLGPDTerm: false,
    };
  },
  watch: {
    agreed(val) {
      if (val) {
        if (this.isFlamengo()) {
          this.showLGPDTerm = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "campaignLandingPageConfig",
    ]),
    termText() {
      return this.campaignLandingPageConfig.campaign.company.lgpdText
        ? this.campaignLandingPageConfig.campaign.company.lgpdText
        : "Deseja receber comunicações futuras desta organização?";
    },
    showLGPD() {
      return (this.campaignLandingPageConfig &&
      this.campaignLandingPageConfig.campaign &&
      this.campaignLandingPageConfig.campaign.company) ?
      (this.campaignLandingPageConfig.campaign.company.enableLGPD && this.campaignLandingPageConfig.campaign.enableLGPD) : false;
    }
  },
  async created() {
    this.$store.dispatch("setRegisterUser", this.person);
  },
  methods: {
    changeLevelPassword(levelPassword) {
      this.levelPassword = levelPassword;
    },
    isFlamengo() {
      if (this.campaignLandingPageConfig && this.campaignLandingPageConfig.campaignId === 737) {
        return true;
      } else {
        return false;
      }
    },
    closeLGPD() {
        this.showLGPDTerm = false;
    },
    disabledButton() {
      const validPassword =
        this.password.length >= 8 &&
        this.levelPassword >= 2 &&
        this.password === this.passwordConfirm;

      const acceptedTerms =
        this.agreedWithTerms &&
        (!this.showLGPD || this.agreed != null); // só exige `agreed` se showLGPD() for true

      this.disableButtonRegister = !(validPassword && acceptedTerms);
    },
    recoverPassword() {
      if (this.person) {
        this.person.user.password = this.password;
        this.person.user.optin = this.optin;
        this.person.registerInline = true;
        this.personService.registerAndLogin(
          this.person,
          this.callbackRegisterAndLogin
        );
      } else if (this.$route.query.tempHash) {
        this.userService
          .recoverPassword(
            this.$route.query.tempHash,
            this.password,
            this.passwordConfirm,
            this.optin
          )
          .then(
            function (success) {
              this.$router.push({ name: Routes.app.DashboardPF });
            }.bind(this)
          );
      } else {
        this.$store.commit("SET_SNACKBAR_MESSAGE", "Usuário não cadastrado.");
      }
    },
    callbackRegister(person) {
      this.$store.dispatch("setRegisterUser", person);
      this.$emit("register");
    },
    callbackRegisterAndLogin(loginResult) {
      this.loginService.saveLoggedUser(this.person.email);


      this.saveLGPD(loginResult)

      
    },
    getLogo() {
      if (
        this.landingPageConfig != null &&
        this.landingPageConfig.campaign != null &&
        this.landingPageConfig.campaign.file != null
      ) {
        return this.landingPageConfig.campaign.file;
      }
      return null;
    },
    getBg() {
      if (
        this.landingPageConfig != null &&
        this.landingPageConfig.heroFile != null
      ) {
        return this.landingPageConfig.heroFile;
      }
      return null;
    },
    gaLightBox() {
      return ga(
        "send",
        "pageview",
        "/home/lightbox/acesso-conta/cadastro-senha"
      );
    },
    async saveLGPD(loginResult) {
        if (!this.showLGPD) {
          this.$emit("registerAndLogin", loginResult);
          return;
        }
        this.userCompanyConsentTerm.companyId = this.campaignLandingPageConfig.campaign.company.id
        this.userCompanyConsentTerm.ipAddress = await this.getIP();
        this.userCompanyConsentTerm.accepted = this.agreed;

        this.userCompanyConsentTermService.save(this.userCompanyConsentTerm).then((res) => {
          this.$emit("registerAndLogin", loginResult);
        })
    },
    async getIP() {
      try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
      } catch (error) {
        console.error('Erro ao buscar o IP:', error);
        return null
      }
    },
    async getUserId(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

      const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

      const jsonPayload = Buffer.from(padded, 'base64').toString();
      const payload = JSON.parse(jsonPayload);

      return payload.unique_name;
    }
  },
};
</script>